import React, { useEffect, useState } from 'react'
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer'
import { Table, TD, TH, TR } from "@ag-media/react-pdf-table";
import FetchApi from '../../customhooks/functionFetchApi';

function Viewnewcolerprinting(props) {
    const FetchApis = new FetchApi();
    const [colorall, setColorall] = useState([])

    useEffect(() => {
        FetchApis.FethcGet(`/productcolordetail/getproductByColorId/${props.colorId}`).then((res) => {
            if (res.status == 200) {
                setColorall(res.data.data)
                console.log(res.data.data)
            }
        })
    }, [])
    function sumkgformulate() {
        let kg1 = 0;
        for (let index = 0; index < colorall.length; index++) {
            kg1 += parseFloat(colorall[index].formulate)

        }

        if (colorall.length > 0) {
            if (kg1 >= 99.99) {
                kg1 = 100;
            }

        }

        return kg1.toFixed(2)
    }

    function sumkg() {

        let kg2 = 0;
        for (let index = 0; index < colorall.length; index++) {
            kg2 += parseFloat(colorall[index].kg1)

        }

        if (kg2 >= parseFloat(colorall[0].Kg_params)) {
            kg2 = parseFloat(colorall[0].Kg_params)

        } else {
            let data1 = kg2 - parseFloat(colorall[0].Kg_params);

            if (data1.toFixed(3) == -0.001) {
                kg2 = parseFloat(colorall[0].Kg_params);
            }

        }
        return kg2.toFixed(3)
    }

    return (
        <>
            <table style={{width:'80%'}}>
                <tr style={{ backgroundColor: '#e5e7e9'}}>
                    <td style={{ justifyContent: 'center',width:'30%'}}><center>Ink Name </center></td>
                    <td style={{ justifyContent: 'center',width:'30%' }}><center>Formulate</center></td>
                    <td style={{ justifyContent: 'center',width:'30%' }}><center>{colorall.length > 0 && colorall[0].Kg_params} kg/1,000 sht</center></td>
                </tr>
                {
                    colorall.map((item, i) => (
                        <tr style={{ backgroundColor: '#e5e7e9'}}>
                            <td ><label style={{ marginLeft: 3}}>{i + 1}. {item.inkname}</label></td>
                            <td style={{ justifyContent: 'center'}}><center>{item.formulate}</center></td>
                            <td style={{ justifyContent: 'center'}}><center>{item.kg1}</center></td>

                        </tr>
                    ))
                }
                <tr>
                    <td style={{ justifyContent: 'center'}}><label style={{ marginLeft: 3, fontWeight: 'bold' }}>Total </label></td>
                    <td style={{ justifyContent: 'center', fontWeight: 'bold',color:'green',fontSize:14}}><center>{colorall.length > 1 && sumkgformulate()}</center></td>
                    <td style={{ justifyContent: 'center', fontWeight: 'bold',color:'green',fontSize:14}}><center>{colorall.length > 1 && sumkg()}</center></td>
                </tr>
            </table>
        </>
    )
}

export default Viewnewcolerprinting